module.exports = __webpack_public_path__ + "static/media/spirited_away.ba2081ad.jpg";